import React, { useEffect } from 'react';
import { Experiment } from '../../types/Experiment';
import { DH } from '../../utils/dataHooks';
import { PaymentMethodsList } from '../PaymentMethodsList';
import { Props } from './controller.connect';

export const ResourcesLoaderController: React.FC<Props> = (props) => {
  const {
    isPayPalPmAvailable,
    areResourcesLoaded,
    bnCode,
    clientId,
    currency,
    fedopsLogger,
    loadPayPalScript,
    checkPayPalMethodsEligibility,
    merchantId,
    experiments,
  } = props;

  useEffect(() => {
    if (isPayPalPmAvailable) {
      loadPayPalScript({
        bnCode,
        clientId,
        currency,
        merchantId,
        testBuyerCountry: experiments.enabled(Experiment.EnablePPCreditAndVenmoTest),
        fedopsLogger,
      }).then(() => {
        checkPayPalMethodsEligibility();
      });
    }
  }, [bnCode, clientId, currency, merchantId]);
  return <div data-hook={DH.Widget.ResourceLoader}>{areResourcesLoaded ? <PaymentMethodsList /> : null}</div>;
};
